// Date 2022-07-08 14:26:47

import sithMesTpmOperateModeTom from "@/store/sithMes/tpm/SithMesTpmOperateModeTomStore.js";
import sithMesTpmProgramStatusTps from "@/store/sithMes/tpm/SithMesTpmProgramStatusTpsStore.js";
import sithMesTpmProcessDataTpd from "@/store/sithMes/tpm/SithMesTpmProcessDataTpdStore.js";
import sithMesTpmSpindleDataTsd from "@/store/sithMes/tpm/SithMesTpmSpindleDataTsdStore.js";
import sithMesTpmAxisDataTad from "@/store/sithMes/tpm/SithMesTpmAxisDataTadStore.js";
import sithMesTpmTsdOpcConfigTtc from "@/store/sithMes/tpm/SithMesTpmTsdOpcConfigTtcStore.js";
import sithMesTpmWarningDataTwd from "@/store/sithMes/tpm/SithMesTpmWarningDataTwdStore.js";

const genericEntities = [
    'sithMesTpmOperateModeTom',
    'sithMesTpmProgramStatusTps',
    'sithMesTpmProcessDataTpd',
    'sithMesTpmSpindleDataTsd',
    'sithMesTpmAxisDataTad',
    'sithMesTpmTsdOpcConfigTtc',
    'sithMesTpmWarningDataTwd'
]

const entities = {
    sithMesTpmOperateModeTom,
    sithMesTpmProgramStatusTps,
    sithMesTpmProcessDataTpd,
    sithMesTpmSpindleDataTsd,
    sithMesTpmAxisDataTad,
    sithMesTpmTsdOpcConfigTtc,
    sithMesTpmWarningDataTwd
}

export {genericEntities}

export default entities